import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
  Inject,
  Optional
} from "@angular/core";
import {
  UntypedFormGroup,
  FormControl,
  UntypedFormBuilder,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { CoreService } from "../../services/coreService";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

declare let toastr: any;

@Component({
    selector: "parking-staff-modal",
    templateUrl: "./parking-staff-modal.component.html",
    styleUrls: ["./parking-staff-modal.component.scss"],
    standalone: true,
    imports: [ReactiveFormsModule]
})
export class ParkingStaffModalComponent implements OnInit, OnChanges {
  staffs: any;
  form: UntypedFormGroup;
  attemptedSubmit = false;
  @Input() parkingID = null;
  @Output() close = new EventEmitter();
  @Output()
  submit = new EventEmitter<{
    user: number;
    parking_place: number;
  }>();
  constructor(
    private builder: UntypedFormBuilder,
    private coreService: CoreService,
    public dialogRef: MatDialogRef<ParkingStaffModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const { parkingID } = this.data;
    this.parkingID = parkingID;
    this.form = this.builder.group({
      parking_place: [this.parkingID, Validators.required],
      user: ["", [Validators.required]]
    });
  }

  closeModal() {
    this.resetModal();
    this.close.emit();
    this.dialogRef.close(null);
  }

  resetModal() {
    this.form.reset();
    this.form.setValue({
      parking_place: this.parkingID,
      user: ""
    });
    this.attemptedSubmit = false;
  }

  submitForm() {
    console.log(this.form.value);
    this.attemptedSubmit = true;
    if (this.form.valid) {
      this.submit.emit(this.form.value);
      this.dialogRef.close(this.form.value);
      // this.resetModal();
    } else {
      toastr.error("", "Form is invalid.", {
        timeOut: 2000
      });
    }
  }

  ngOnInit() {
    this.coreService
      .GetStaff()
      .then(result => {
        this.staffs = result;
      })
      .catch(err => {
        console.log(err);
        toastr.error("", "Failed to fetch staff list.", {
          timeOut: 2000
        });
        this.closeModal();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.parkingID.currentValue != null) {
      this.resetModal();
    }
  }
}
